import { SVGProps } from 'react';
const SvgHandbag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M18.153 8H5.847a1 1 0 0 0-.986.836l-1.667 10A1 1 0 0 0 4.18 20h15.64a1 1 0 0 0 .986-1.164l-1.667-10A1 1 0 0 0 18.153 8ZM8 8a4 4 0 1 1 8 0"
    />
  </svg>
);
export default SvgHandbag;
